/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />

module Meevo.Components.Controls {

  class InfinityListSelectComponent implements ng.IComponentController {
    static $inject = [
      '$scope'
    ];

    allSelected: boolean;
    collection: any[];
    filterredCollection: any[];
    displayKey: string;
    contentKey: string;
    idKey: string;
    onValueChanged?: (model, modelSelected) => any;
    filter: string;


    constructor(private $scope: ng.IScope) {
    }

    $onInit() {
      this.displayKey = this.displayKey || 'displayName';
      this.idKey = this.idKey || 'id';
      this.allSelected = true;

      this.$scope.$watch(() => this.collection, () => {
        this.filterChange(this.filter);
      });
      this.filterChange(this.filter);
    }

    onChangedCallback(model, modelSelected) {
      if (typeof this.onValueChanged === 'function') {
        this.onValueChanged(model, modelSelected);
      }
    }

    filterChange(word?: string) {
      if (!word) return this.filterredCollection = this.collection;

      this.filterredCollection = this.collection.filter((row) => {
        return row[this.displayKey].toLowerCase().indexOf(word.toLowerCase()) !== -1
      });
    }
  }

  angular.module('meevo.components.controls')
    .component('infinityListSelect', <angular.IComponentOptions>{
      templateUrl: 'app/components/controls/infinity-list-select/infinity-list-select.component.html',
      controller: InfinityListSelectComponent,
      controllerAs: '$ctrl',
      bindings: {
        collection: '<',
        displayKey: '<',
        idKey: '<',
        contentKey: '@',
        onValueChanged: '=?'
      }
    });
}
